/**
 * SEO Configuration
 * 
 * Centralized SEO meta tags for all pages.
 * Optimized for Google Ads, LinkedIn Ads, and organic search.
 * 
 * Each page has:
 * - Title (optimized for CTR)
 * - Description (155 chars, includes CTA)
 * - Keywords (industry-specific)
 * - OG Image (for social sharing)
 */

export const seoConfig = {
  en: {
    home: {
      title: "DSI Durango - CNC Machining & Industrial Automation | Mexico",
      description: "Industrial CNC machining, harness fixtures, and automation solutions. Specialists in G10/FR4, precision parts, and custom tooling. ISO 9001 certified. Monterrey & Durango, Mexico.",
      keywords: "CNC machining Mexico, G10 FR4 machining, harness fixtures, industrial automation, precision machining, Dynalab integrator, custom tooling Mexico",
      ogImage: "/images/home/hero.jpg"
    },
    cnc: {
      title: "Precision CNC Machining in G10, FR4 & Phenolics | DSI Durango",
      description: "CNC machining specialists in G10, FR4, phenolics, and aluminum. Precision parts with ±0.05mm tolerance. ISO 9001 certified. Small to medium batches. Fast turnaround.",
      keywords: "CNC machining G10, FR4 machining, phenolic machining, bakelite CNC, precision CNC Mexico, G10 parts, FR4 parts, CNC aluminum, engineering plastics machining",
      ogImage: "/images/cnc/hero.jpg"
    },
    harness: {
      title: "Custom Harness Assembly Fixtures & Dynalab Integration | DSI",
      description: "Custom fixture design and manufacturing for wire harness assembly. Authorized Dynalab integrator. Automotive-grade quality. Testing solutions with high repeatability.",
      keywords: "harness fixtures, wire harness tooling, Dynalab integrator, harness assembly fixtures, automotive harness tooling, harness testing, wire routing fixtures Mexico, electrical test fixtures, electrical test benches, electrical test boards, assembly boards, holders, continuity checkers, TSK alternative, EMDEP alternative, TKM alternative, SIE alternative, test fixture manufacturer, harness test equipment, Data Center Power Systems testing, data center rack power connector testing, hi-pot testing, high voltage testing, ev busbar testing solutions, busbar tester, ev contactor tester",
      ogImage: "/images/harness/hero.jpg"
    },
    automation: {
      title: "Industrial Automation & Testing Stations | DSI Durango",
      description: "Custom automation solutions with PLC control, vision systems, and quality inspection. From concept to implementation. Testing stations, assembly cells, and inspection systems.",
      keywords: "industrial automation Mexico, PLC automation, vision systems, testing stations, assembly automation, quality inspection automation, automated testing, custom automation, test benches, electrical test modules, test fixtures, assembly fixtures, production test equipment, TSK competitor, EMDEP competitor, TKM competitor, SIE competitor, ev contactor assembly line, ev busbar assembly,desoutter integrators, custom fastener insertion machine, custom electrical test,  hi-pot testing, high voltage testing,  custom leak test machine, uson system integrators, fukuda system integrators",
      ogImage: "/images/automation/hero.jpg"
    },
    privacy: {
      title: "Privacy Policy",
      description: "Privacy policy for DSI Durango. Learn how we collect, use, and protect your personal information.",
      keywords: "privacy policy, data protection, GDPR compliance",
      ogImage: "/images/logo/dsi-logo.png"
    },
    terms: {
      title: "Terms of Service",
      description: "Terms of service for DSI Durango. Legal terms and conditions for using our website and services.",
      keywords: "terms of service, legal terms, conditions",
      ogImage: "/images/logo/dsi-logo.png"
    }
  },
  es: {
    home: {
      title: "DSI Durango - Maquinado CNC y Automatización Industrial | México",
      description: "Maquinado CNC industrial, fixtures para arneses y soluciones de automatización. Especialistas en G10/FR4, piezas de precisión y herramentales. ISO 9001. Monterrey y Durango.",
      keywords: "maquinado CNC México, maquinado G10 FR4, fixtures arneses, automatización industrial, maquinado precisión, integrador Dynalab, herramentales México",
      ogImage: "/images/home/hero.jpg"
    },
    cnc: {
      title: "Maquinado CNC de Precisión en G10, FR4 y Fenólicos | DSI Durango",
      description: "Especialistas en maquinado CNC de G10, FR4, fenólicos y aluminio. Piezas de precisión con tolerancia ±0.05mm. Certificado ISO 9001. Lotes pequeños y medianos. Entrega rápida.",
      keywords: "maquinado CNC G10, maquinado FR4, maquinado fenólicos, CNC baquelita, maquinado precisión México, piezas G10, piezas FR4, CNC aluminio, plásticos ingeniería",
      ogImage: "/images/cnc/hero.jpg"
    },
    harness: {
      title: "Fixtures Personalizados para Arneses e Integración Dynalab | DSI",
      description: "Diseño y fabricación de fixtures personalizados para ensamble de arneses. Integrador autorizado Dynalab. Calidad automotriz. Soluciones de prueba con alta repetibilidad.",
      keywords: "fixtures arneses, herramental arneses, integrador Dynalab, fixtures ensamble arneses, herramental automotriz, prueba arneses, fixtures ruteo cables México, bancos de prueba eléctrica, módulos de prueba eléctrica, checkers de continuidad, mesas de prueba, holders, bancos de prueba, tableros de prueba eléctrica, alternativa a TSK, alternativa a EMDEP, alternativa a TKM, alternativa a SIE, fabricante fixtures prueba,prueba electrica busbar, prueba electrica alto voltaje, pruebas hipot, herramental, pull system, holders push out, holders push back",
      ogImage: "/images/harness/hero.jpg"
    },
    automation: {
      title: "Automatización Industrial y Estaciones de Prueba | DSI Durango",
      description: "Soluciones de automatización con control PLC, sistemas de visión e inspección de calidad. Del concepto a la implementación. Estaciones de prueba, celdas de ensamble y sistemas de inspección.",
      keywords: "automatización industrial México, automatización PLC, sistemas visión, estaciones prueba, automatización ensamble, inspección calidad automatizada, pruebas automatizadas, automatización personalizada, bancos de prueba, mesas de prueba, módulos prueba eléctrica, fixtures prueba eléctrica, tableros ensamble, competidor TSK, competidor EMDEP, competidor TKM, competidor SIE, integrador prueba fuja, integrador fukuda, integrador uson, integrador desoutter, integrador keyence, integrador cognex, instalador robots, integrador robots, linea ensamble de contactores, prueba electrica busbar, prueba electrica alto voltaje, pruebas hipot",
      ogImage: "/images/automation/hero.jpg"
    },
    privacy: {
      title: "Política de Privacidad",
      description: "Política de privacidad de DSI Durango. Conoce cómo recopilamos, usamos y protegemos tu información personal.",
      keywords: "política privacidad, protección datos, cumplimiento GDPR",
      ogImage: "/images/logo/dsi-logo.png"
    },
    terms: {
      title: "Términos de Servicio",
      description: "Términos de servicio de DSI Durango. Términos y condiciones legales para usar nuestro sitio web y servicios.",
      keywords: "términos servicio, términos legales, condiciones",
      ogImage: "/images/logo/dsi-logo.png"
    }
  }
};

/**
 * Get SEO config for a specific page
 * @param {string} page - Page identifier (home, cnc, harness, automation)
 * @param {string} language - Language code (en, es)
 * @returns {Object} SEO configuration object
 */
export const getSEOConfig = (page, language = 'en') => {
  return seoConfig[language][page] || seoConfig[language].home;
};
